<template>
    <div class="block-split__item block-split__item-content col-auto">
        <div class="product product--layout--sidebar">
            <div class="product__body">
                <div class="product__card product__card--one"></div>
                <div class="product__card product__card--two"></div>
                <div class="product__header">
                    <h1 class="product__title">Engine Rebuild Kit - {{product.desc}}</h1>
                    <div class="product__subtitle">
                        <div class="flex-item-page-info-selected-vehcile">
                            <div class="flex-container--breadcrumbs-selected-vehicle">
                                <div class="flex-container--select-vehicle-column">
                                    <div class="vehicles-list__item-name">
                                        <span v-if="kit_vehicle.year != null">{{ kit_vehicle.year_desc }}</span> 
                                        {{ kit_vehicle.make_desc }} {{ kit_vehicle.eng_desc }}
                                    </div>
                                    <div class="vehicles-list__item-details-category-display">{{ kit_vehicle.vin_desc }}</div>
                                </div>
                                <div class="flex-container--select-vehicle-column">
                                    <div class="product__tags tags tags--sm">
                                        <div class="tags__list tags__list-select-vehicle">
                                            <!-- select-engine__picker change-vehicle__button -->
                                            <button class="select-engine__picker change-vehicle__button" type="button" @click="openSelectVehicle">
                                                <span class="search__button-icon">
                                                    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="30pt" height="30pt" viewBox="0 0 700.000000 518.000000" preserveAspectRatio="xMidYMid meet">
                                                        <g transform="translate(0.000000,518.000000) scale(0.100000,-0.100000)" fill="#fff" stroke="none">
                                                        <path d="M5235 5170 c3 -5 13 -10 21 -10 8 0 14 5 14 10 0 6 -9 10 -21 10 -11
                                                        0 -17 -4 -14 -10z"></path>
                                                        <path d="M5213 5128 c-18 -11 -33 -24 -33 -30 0 -12 -233 -294 -267 -324 -33
                                                        -29 -24 -58 28 -84 21 -11 39 -24 39 -28 0 -4 34 -34 76 -67 116 -91 256 -206
                                                        280 -229 11 -12 48 -40 82 -64 33 -24 76 -57 95 -75 19 -18 47 -42 63 -55 16
                                                        -12 94 -75 173 -140 79 -64 179 -145 224 -179 44 -34 98 -79 121 -100 23 -21
                                                        66 -56 97 -78 58 -42 68 -50 127 -104 20 -18 64 -54 97 -79 85 -65 177 -142
                                                        196 -165 17 -20 39 -16 39 7 0 8 7 19 15 26 8 7 39 45 69 84 30 39 67 85 83
                                                        103 52 59 117 141 132 171 17 32 6 59 -53 124 -90 101 -382 390 -471 468 -48
                                                        41 -106 92 -129 113 -22 21 -66 57 -96 80 -30 23 -91 71 -135 107 -44 37 -93
                                                        75 -109 86 -16 10 -43 29 -60 42 -17 12 -47 33 -66 47 -19 13 -53 38 -75 54
                                                        -22 17 -49 35 -60 40 -11 5 -29 18 -39 30 -11 11 -24 21 -30 21 -6 0 -36 18
                                                        -66 40 -30 22 -71 47 -90 56 -19 9 -42 22 -51 30 -15 13 -164 95 -171 93 -2 0
                                                        -18 -10 -35 -21z"></path>
                                                        <path d="M1700 5121 c-19 -11 -49 -27 -66 -35 -16 -8 -61 -35 -100 -60 -38
                                                        -25 -74 -46 -80 -46 -6 0 -18 -7 -25 -16 -7 -9 -43 -36 -79 -60 -36 -24 -74
                                                        -50 -85 -57 -11 -8 -45 -30 -75 -51 -59 -39 -205 -148 -255 -190 -16 -14 -59
                                                        -48 -95 -75 -96 -74 -213 -177 -355 -313 -44 -42 -98 -92 -121 -110 -23 -19
                                                        -56 -52 -75 -73 -18 -22 -80 -89 -136 -148 -83 -87 -103 -114 -103 -138 0 -29
                                                        53 -107 149 -218 36 -42 62 -74 129 -160 12 -16 22 -34 22 -39 0 -22 22 -23
                                                        43 -2 12 12 67 57 122 100 55 44 109 87 120 97 64 58 158 133 166 133 5 0 28
                                                        18 52 40 75 73 221 190 244 196 12 3 25 15 28 25 4 10 10 19 15 19 5 0 22 12
                                                        38 28 16 15 42 37 58 49 16 13 59 48 96 78 36 30 71 55 77 55 6 0 15 8 20 18
                                                        6 9 42 42 81 72 72 55 169 135 225 183 102 89 329 267 341 267 7 0 21 12 30
                                                        26 17 24 16 26 -12 54 -49 50 -124 139 -201 240 -103 135 -125 148 -193 111z"></path>
                                                        <path d="M4716 4520 c-20 -22 -36 -43 -36 -48 0 -4 -22 -30 -48 -59 -54 -59
                                                        -68 -77 -158 -190 -36 -46 -69 -83 -74 -83 -6 0 -10 -5 -10 -11 0 -6 -21 -37
                                                        -47 -69 -27 -32 -70 -86 -98 -121 -27 -35 -62 -77 -77 -94 -38 -43 -61 -70
                                                        -123 -150 -64 -82 -90 -114 -127 -155 -16 -17 -28 -37 -28 -46 0 -14 63 -84
                                                        75 -84 4 0 36 -25 72 -56 73 -62 76 -62 169 -18 28 13 59 24 68 24 10 0 31 9
                                                        46 20 16 11 48 23 72 26 45 6 71 -8 151 -81 15 -14 32 -25 37 -25 6 0 10 -7
                                                        10 -15 0 -9 8 -18 18 -22 28 -10 72 -55 72 -75 0 -20 -141 -203 -217 -282 -13
                                                        -13 -23 -27 -23 -30 0 -14 -155 -192 -249 -286 -53 -53 -134 -126 -181 -162
                                                        -47 -37 -92 -73 -100 -80 -44 -37 -96 -72 -148 -100 -47 -25 -70 -31 -127 -32
                                                        -67 -1 -73 1 -129 39 -128 88 -180 114 -248 122 -136 16 -247 -67 -509 -384
                                                        -74 -89 -159 -197 -189 -239 -30 -43 -63 -85 -72 -93 -10 -9 -18 -23 -18 -33
                                                        0 -10 -10 -28 -22 -40 -13 -12 -37 -45 -55 -73 -17 -27 -39 -60 -48 -73 -82
                                                        -114 -96 -206 -45 -296 29 -51 122 -156 139 -156 18 0 121 -114 132 -147 6
                                                        -19 17 -47 25 -61 8 -15 14 -36 14 -48 0 -12 11 -41 23 -65 13 -24 27 -57 31
                                                        -73 4 -17 17 -39 29 -51 12 -12 39 -39 59 -61 20 -21 49 -49 65 -62 74 -59 92
                                                        -72 101 -72 6 0 23 -10 39 -23 15 -13 54 -29 85 -36 32 -7 60 -17 63 -22 4 -5
                                                        34 -9 68 -9 131 0 211 -27 284 -95 35 -33 55 -48 103 -80 42 -28 52 -30 156
                                                        -33 l110 -4 160 160 c87 88 188 192 224 233 36 40 79 88 95 106 17 17 53 62
                                                        80 99 28 37 59 76 70 88 11 11 25 28 30 37 6 9 28 43 50 75 43 62 51 77 108
                                                        186 66 130 45 230 -74 344 -28 27 -59 57 -68 67 -9 10 -26 28 -39 41 -48 50
                                                        -50 228 -3 295 10 14 21 39 25 54 4 15 15 35 26 45 11 9 20 27 20 39 0 33 66
                                                        155 150 278 8 12 28 41 43 64 35 53 106 150 130 176 9 11 54 65 98 120 45 55
                                                        89 107 98 115 10 8 36 39 60 68 32 39 49 52 69 52 30 0 88 -42 189 -137 l66
                                                        -63 -10 -119 c-7 -81 -16 -129 -29 -149 -16 -28 -16 -32 -2 -54 9 -13 52 -53
                                                        96 -88 45 -36 81 -70 82 -76 0 -6 7 -17 15 -24 21 -17 62 1 74 32 5 13 19 35
                                                        32 50 13 15 44 50 69 78 25 28 50 59 55 69 6 9 60 77 120 150 61 73 117 143
                                                        125 154 8 12 32 43 55 69 22 26 51 61 65 79 14 17 36 44 50 60 44 51 70 83
                                                        101 124 43 57 110 136 140 164 l25 25 -58 58 c-32 32 -61 58 -65 58 -9 0 -135
                                                        99 -169 133 -23 23 -34 32 -124 98 -30 22 -76 59 -101 82 -25 23 -59 52 -75
                                                        64 -75 58 -230 186 -240 199 -6 8 -16 14 -22 14 -7 0 -19 11 -28 25 -9 14 -21
                                                        25 -26 25 -8 0 -65 43 -119 90 -10 8 -36 29 -58 45 -22 17 -40 36 -41 43 0 7
                                                        -12 17 -26 23 -15 5 -41 21 -58 34 -73 58 -89 72 -124 104 -20 18 -62 52 -92
                                                        75 -59 44 -213 172 -270 224 -19 18 -37 32 -41 32 -4 0 -23 -18 -43 -40z m531
                                                        -1009 c67 -24 110 -67 134 -134 23 -62 23 -65 4 -131 -47 -162 -241 -213 -361
                                                        -95 -115 113 -74 301 79 360 56 23 83 22 144 0z m-1722 -1950 c22 -10 53 -21
                                                        69 -25 64 -16 175 -125 219 -216 30 -61 32 -72 31 -170 0 -98 -2 -109 -31
                                                        -164 -31 -58 -156 -196 -177 -196 -6 0 -32 -11 -58 -25 -41 -22 -59 -25 -145
                                                        -25 -85 1 -106 4 -158 28 -33 15 -69 35 -80 45 -11 9 -37 31 -57 48 -21 17
                                                        -38 36 -38 42 0 6 -7 19 -17 29 -62 68 -93 250 -55 324 10 22 22 52 26 68 11
                                                        45 82 132 143 173 27 18 103 52 173 76 34 12 117 6 155 -12z"></path>
                                                        <path d="M2225 4539 c-4 -6 -25 -23 -47 -39 -22 -16 -61 -47 -86 -69 -26 -22
                                                        -78 -65 -117 -95 -83 -66 -119 -95 -143 -117 -9 -9 -64 -54 -122 -100 -58 -45
                                                        -143 -115 -190 -154 -47 -39 -103 -84 -125 -100 -22 -16 -50 -38 -61 -49 -12
                                                        -12 -35 -32 -52 -46 -17 -14 -43 -35 -57 -47 -14 -13 -30 -23 -35 -23 -5 0
                                                        -24 -13 -42 -30 -18 -16 -42 -38 -53 -47 -30 -27 -208 -173 -266 -218 -28 -22
                                                        -66 -53 -84 -70 -18 -16 -63 -52 -99 -80 -102 -76 -154 -127 -136 -133 29 -9
                                                        94 -84 285 -324 25 -31 45 -61 45 -67 0 -5 8 -12 18 -15 9 -3 25 -18 35 -33
                                                        33 -53 68 -99 124 -161 31 -35 75 -88 97 -117 23 -29 79 -99 126 -156 47 -57
                                                        93 -116 103 -131 9 -15 26 -32 38 -39 18 -9 25 -6 53 23 64 67 116 109 151
                                                        124 36 15 37 17 32 57 -2 23 -12 67 -21 97 -8 30 -19 90 -22 133 -8 92 -13 84
                                                        129 198 127 103 133 103 217 2 35 -43 71 -85 80 -93 28 -25 156 -183 170 -210
                                                        7 -14 21 -31 32 -38 10 -7 18 -19 18 -26 0 -7 9 -21 20 -31 28 -25 130 -178
                                                        130 -194 0 -7 11 -26 25 -43 14 -16 25 -42 25 -58 0 -36 19 -49 37 -24 7 10
                                                        31 39 53 64 22 25 67 78 101 119 68 80 225 239 277 278 38 30 41 50 9 62 -35
                                                        14 -247 229 -247 251 0 6 -19 30 -42 54 -24 24 -54 58 -68 76 -14 18 -34 43
                                                        -46 54 -12 12 -26 31 -33 44 -7 13 -42 59 -78 104 -80 99 -81 94 70 218 122
                                                        101 142 107 218 67 24 -13 60 -27 80 -31 20 -3 44 -15 54 -26 13 -14 31 -20
                                                        62 -20 39 0 52 7 132 73 49 39 96 77 106 82 15 9 15 14 4 40 -7 17 -20 37 -30
                                                        45 -9 8 -65 76 -124 150 -59 74 -114 142 -122 150 -7 8 -38 47 -69 85 -105
                                                        133 -141 177 -172 210 -11 11 -25 31 -32 44 -7 13 -32 45 -56 70 -24 25 -44
                                                        51 -44 58 0 7 -7 16 -15 20 -22 13 -135 153 -135 169 0 7 -14 20 -32 28 -37
                                                        19 -45 20 -53 5z m-321 -1027 c52 -14 106 -72 135 -144 l23 -58 -24 -65 c-32
                                                        -92 -75 -132 -159 -149 -88 -18 -147 -2 -205 55 -54 53 -71 117 -55 206 9 50
                                                        17 64 60 106 30 28 59 47 73 47 13 0 30 5 38 10 16 11 49 9 114 -8z"></path>
                                                        </g>
                                                    </svg>
                                                </span>
                                                <span class="search__button-title">Select Another Engine</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product__info">
                    <div class="product__info-card">
                        <div class="product__info-body">
                            <div class="product__prices-stock">
                                <div class="product__prices">
                                    <div class="product__price product__price--current">{{toUSD(p_gtotal)}}</div>
                                </div>
                            </div>
                            <div class="in-stock">
                                <div class="status-badge status-badge--style--success product__stock status-badge--has-text">
                                    <div class="status-badge__body">
                                        <div class="status-badge__text">In Stock</div>
                                        <div class="status-badge__tooltip" tabindex="0" data-toggle="tooltip" title="" data-original-title="In Stock"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="product__meta">
                                <table>
                                    <tbody>
                                        <tr><th>Item Number</th><td>{{product.item}}</td></tr>
                                        <!-- <tr><th>Manufacturer</th><td><a href="">{{product.manufacturername}}</a></td></tr> -->
                                        <tr><th>Manufacturer Code</th><td>{{product.manufacturer}}</td></tr>
                                        <!-- <tr><th>Warranty</th><td>1 Year</td></tr> -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="product__actions">
                            <div class="product__actions-item product__actions-item--addtocart">
                                <button class="btn btn-primary btn-lg btn-block" @click.prevent="$emit('addToCart')">Add to cart</button>
                            </div>
                            <div class="product__actions-divider"></div>
                        </div>
                    </div>
                    <div></div>
                </div>
                <!-- <div class="product__tabs product-tabs product-tabs--layout--sidebar">
                    <ul class="product-tabs__list">
                        <li class="product-tabs__item product-tabs__item--active"><a href="#product-tab-description">Description</a></li>
                    </ul>
                    <div class="product-tabs__content">
                        <div class="product-tabs__pane product-tabs__pane--active" id="product-tab-description">
                            <div class="typography">
                                <p> {{product.long_desc}}</p>
                            </div>
                        </div>
                    </div>
                </div> -->
                <detail-tabs :tabs="tabs" :default-tab="defaultTab" :prod_desc="prod_desc" :attributes="attributes"></detail-tabs>
            </div>
        </div>
        <div class="block-space block-space--layout--divider-15"></div>
    </div>
    
    <kit-vehicle-dialog @close="openDialog = false" :open="openDialog" main_category="ENGKT"></kit-vehicle-dialog>
</template>

<script>

import MXPrice from '../../../mixins/price';
import MXVehicleSearch from '../../../mixins/vehicle_search.js';
import { mapGetters } from 'vuex';
import KitVehicleDialog from './KitVehicleDialog.vue';
import DetailTabs from "./DetailTabs";
import axiosvl from "../../../axios/axios-vl.js";

export default {
  components: {KitVehicleDialog, DetailTabs},
    data() {
        return {
            openDialog: false,
            p_gtotal: this.gtotal,

            // detail tabs properties
            tabs: [],
            attributes: [],
            prod_desc: '',
            defaultTab: '',
        }
    },
    computed:{
        ...mapGetters('vehicle',[
            'kit_vehicle'
        ]),
    },
    props: {
        product: {
            type: Object,
        },
        gtotal: {
            type: Number,
        }
    },
    emits: ['addToCart'],
    mixins: [MXPrice, MXVehicleSearch],
    methods: {
        openSelectVehicle() {
          this.openDialog = true;
        },
        closeSelectVehicle() {
          this.openDialog = false;
        },
        getCEAttributes() {
            this.isloading = true;
            this.tabs = [], this.attributes = [];

            axiosvl.post(this.$store.getters['api/get_ce_prod_attributes_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        // "HOSTURL": { "value": this.$store.getters.hosturl },
                        "LW3SFID": { "value": this.$store.getters.storefront },
                        "LW3MFR": { "value": this.$route.params.manufacturer },
                        "LW3ITEMCD": { "value": this.$route.params.kitnumber },
                    },   
                }
            })
            .then((response) => {
                for (const key in response.data.webroutine.lists.LS_PRODUCTATTRIBUTES.entries) {
                    const obj = response.data.webroutine.lists.LS_PRODUCTATTRIBUTES.entries[key];
                    this.attributes.push({
                        id: obj.LW3IATID,
                        sequence: obj.LW3IATSQ,
                        name: obj.LW3IATNM,
                        value: obj.LW3IATVL
                    });
                }

                for (const key in response.data.webroutine.lists.LS_PRODUCTTABS.entries) {
                    const obj = response.data.webroutine.lists.LS_PRODUCTTABS.entries[key];
                    if (obj.LW3IATNM == 'Alternatives' || obj.LW3IATNM == 'Reviews'){
                        continue;
                    }

                    if(obj.LW3IATNM == 'Description' && obj.LW3IATVL == '') {
                        obj.LW3IATVL = this.product.long_desc;
                    }

                    this.tabs.push({
                        index: obj.LW3IATTI,
                        name: obj.LW3IATNM,
                        content: obj.LW3IATVL
                    });
                }

                if (this.tabs.length > 0) {
                    this.defaultTab = this.tabs[0].name;
                }

                this.isloading = false;

            })
            .catch((error) => {
                console.log("error on CE Attribute - " + error);
                this.isloading = false;
            });
        },
        
    },
    watch: {
        // modelValue(newVal) {
        //     this.$emit('kitqty_changed', newVal);
        // }
    },
    mounted() {
        // console.table(this.kit_vehicle);
        
        this.getCEAttributes();
    },

    updated() {
        // console.log('gtotal = ' + this.gtotal);
        // console.log(this.product);
        this.p_gtotal = this.gtotal;
        if(this.tabs[0].name == 'Description' && (this.tabs[0].content == '' || this.tabs[0].content == undefined )) {
            this.tabs[0]['content'] = this.product.long_desc;
        }
    }
}
</script>

<style scoped>
.product-tabs__item{
    margin-left: 0px !important;
}
</style>